import { render, staticRenderFns } from "./OrderConfirmed.vue?vue&type=template&id=f3c18376"
import script from "./OrderConfirmed.vue?vue&type=script&lang=js"
export * from "./OrderConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c18376')) {
      api.createRecord('f3c18376', component.options)
    } else {
      api.reload('f3c18376', component.options)
    }
    module.hot.accept("./OrderConfirmed.vue?vue&type=template&id=f3c18376", function () {
      api.rerender('f3c18376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/OrderConfirmed.vue"
export default component.exports